import { message } from "antd";
import axiosInstance from "../shared/axios";

// GET
const getPreSessions = async (params) => {
  try {
    let result = await axiosInstance.get("/preSessionInstructions/viewAll", {
      params,
    });

    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading sessions");
      return null;
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading sessions",
    );
    return null;
  }
};

const getPreSessionsSingle = async (id) => {
  try {
    let result = await axiosInstance.get(`/preSessionInstructions/edit/${id}`);

    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading pre instruction");
      return null;
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading pre instruction",
    );
    return null;
  }
};

const addEditPreSessionInstruction = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/preSessionInstructions/update" : "/preSessionInstructions/store",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to save pre-session instructions",
    };
  }
};

const deletePreSessionInstruction = async (id) => {
  try {
    const result = await axiosInstance.delete(
      `/preSessionInstructions/delete/${id}`,
    );

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to delete pre-session instruction",
    };
  }
};

export const presessioninstruction = {
  getPreSessions,
  addEditPreSessionInstruction,
  deletePreSessionInstruction,
  getPreSessionsSingle,
};
